import { createRef } from 'react';
import { FormatNumberOptions, FormatDateOptions } from '@formatjs/intl';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface FormatNumberCustomInterface extends FormatNumberOptions {
  decimals?: number;
}

export const translateRef: any = createRef();

export const formatMessage = (id: string, values?: any, opts?: any): string => {
  return translateRef.current?.state?.intl?.formatMessage({ id }, values, opts);
};

// export const formatDate = (value: any, opts?: FormatDateOptions): string => {
//   return translateRef.current?.state?.intl?.formatDateOnlyIntl(value, opts);
// };

// export const formatDate = (value: string | Date | number) => {
//   if (!value) return '';

//   let dateToFormat;
//   if (typeof value === 'string' && value.endsWith('Z')) {
//     const utcDate = new Date(value);
//     const year = utcDate.getUTCFullYear();
//     const month = utcDate.getUTCMonth();
//     const day = utcDate.getUTCDate();
//     dateToFormat = new Date(year, month, day);
//   } else {
//     dateToFormat = new Date(value);
//   }

//   return new Intl.DateTimeFormat('pt-BR').format(dateToFormat);
// };

export const formatDate = (value: any | Date, hasTime: boolean = true) => {
  if (!value) return '';

  const date = new Date(value);

  return format(date, hasTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy', {
    locale: ptBR
  });
};

export const formatDateWithoutUTC = (value: any | Date, hasTime: boolean = false) => {
  if (!value) return '';

  const date = new Date(value);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  if (hasTime) {
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  return `${day}/${month}/${year}`;
};

export const formatTime = (value: string, opts?: any) => {
  return translateRef.current?.state?.intl?.formatTime(value, opts);
};

export const formatDateTime = (value: any, opts?: FormatDateOptions): string => {
  return formatDate(value) + ' - ' + formatTime(value, opts) + 'h';
};

export const formatNumber = (value: any, opts?: FormatNumberCustomInterface): string => {
  const currency = translateRef.current?.state?.intl?.messages?.currencyFormat;

  return translateRef.current?.state?.intl?.formatNumber(
    isNaN(value) ? 0 : value,
    opts?.style === 'currency'
      ? {
          ...opts,
          currency,
          minimumFractionDigits: opts?.decimals ?? 2
        }
      : opts
  );
};

export const formatDateUTCMinus3ToFilter = (date: Date, isEnd: boolean = false) => {
  const offset = 3 * 60 * 60 * 1000;
  const dateUtcMinus3 = new Date(date.getTime() - offset);

  const year = dateUtcMinus3.getUTCFullYear();
  const month = String(dateUtcMinus3.getUTCMonth() + 1).padStart(2, '0');
  const day = String(dateUtcMinus3.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}T${isEnd ? '23:59:59' : '00:00:00'}`;
};
